import React from "react";

const Frame92 = () => {
      return(
            <div className="frame-parent11">
                  <div className="we-have-what-youre-looking-fo-parent">
                        <b className="about">We have what you’re looking for</b>
                        <div className="lorem-ipsum-is14">
                              Lorem Ipsum is simply dummy text of the printing and typesetting
                              industry. Lorem Ipsum has been the industry's standard dummy text
                              ever since the 1500s, when an unknown printer took a galley of
                              type a
                        </div>
                  </div>
                  <div className="button">
                        <b className="get-started-now">Get Started Now</b>
                  </div>
            </div>
      );
};

export default Frame92;